import { Component } from "react";
import { Link } from "react-router-dom";
import { IoMdLogOut } from "react-icons/io";
import { TfiComments } from "react-icons/tfi";
import { PiDogBold } from "react-icons/pi";
import { FaDog } from "react-icons/fa";
import { FaAward } from "react-icons/fa";
import { FaCameraRetro } from "react-icons/fa";
import { FaWpforms } from "react-icons/fa";
import { FaUserShield } from "react-icons/fa";

const loginReset = 1000 * 60 * 60 * 24; //24 Hours

class Toolbar extends Component<any,any> {

    user:any;

    constructor(props: any) {
        super(props);
        
        var loggedIn = localStorage.getItem('loggedIn');
        this.user = JSON.parse(localStorage.getItem('user') || '{}');
        console.log(loggedIn);
        if (loggedIn != null) {
            var lastlogin = parseInt(loggedIn);
            var now = new Date().getTime();
            if (now - lastlogin < loginReset) {
                
            } else {

                localStorage.removeItem('loggedIn');
                localStorage.removeItem('user');
                window.location.href = '/';
            }
        } else {
            localStorage.removeItem('loggedIn');
            localStorage.removeItem('user');
            window.location.href = '/';
        }
    }

    render() {
        return (<div style={{fontSize: '14pt',fontFamily:'avenir',color: '#fff',width: '200px', backgroundColor: '#000', height: '100%', display: 'flex', flexDirection: 'column', justifyContent: 'flex-start', alignItems: 'center', position: 'fixed'}}>
                <img src="/content/images/logo-hires-white.png" style={{width: '100px'}} /><br/>
                Logged in as {this.user.username}<br/><br/>
                <div className="highlight" onClick={() => {localStorage.removeItem('loggedIn'); localStorage.removeItem('user'); window.location.href = '/';}} style={{display: 'flex', justifyContent: 'center', alignItems: 'center', cursor: 'pointer'  }}>
                    <IoMdLogOut style={{ fontSize: '20pt', }} /> LOGOUT
                </div>
                <div style={{width: '80%'}} className="toolbarItems">
                    <hr style={{border: '1px solid rgba(255,255,255,.2)',marginTop: '20px', marginBottom: '20px'}}></hr>
                    <div style={{cursor: 'pointer',display: 'flex', justifyContent: 'flex-start', alignItems: 'center', marginTop: '10px'}} onClick={()=>{
                        window.location.href = '/useraccess';
                    }}>
                        <FaUserShield size={20} style={{marginRight: '20px'}}/> USER ACCESS
                    </div>
                    <hr style={{border: '1px solid rgba(255,255,255,.2)',marginTop: '20px', marginBottom: '20px'}}></hr>
                    <div style={{cursor: 'pointer',display: 'flex', justifyContent: 'flex-start', alignItems: 'center', marginTop: '10px'}}  onClick={()=>{
                        window.location.href = '/testimonials';
                    }}>
                        <TfiComments size={20} style={{marginRight: '20px'}}/> TESTIMONIALS
                    </div>
                    <div style={{cursor: 'pointer',display: 'flex', justifyContent: 'flex-start', alignItems: 'center', marginTop: '10px'}} onClick={()=>{
                        window.location.href = '/puppies';
                    }}>
                        <PiDogBold size={20} style={{marginRight: '20px'}}/> PUPPIES
                    </div>
                    <div style={{cursor: 'pointer',display: 'flex', justifyContent: 'flex-start', alignItems: 'center', marginTop: '10px'}}  onClick={()=>{
                        window.location.href = '/sires';
                    }}>
                        <FaDog size={20} style={{marginRight: '20px'}}/> SIRES
                    </div>
                    <div style={{cursor: 'pointer',display: 'flex', justifyContent: 'flex-start', alignItems: 'center', marginTop: '10px'}} onClick={()=>{
                        window.location.href = '/dames';
                    }}>
                        <FaDog size={20} style={{marginRight: '20px'}}/> DAMES
                    </div>
                    <div style={{cursor: 'pointer',display: 'flex', justifyContent: 'flex-start', alignItems: 'center', marginTop: '10px'}} onClick={()=>{
                        window.location.href = '/shows';
                    }}>
                        <FaAward size={20} style={{marginRight: '20px'}}/> SHOWS & RESULTS
                    </div>
                    <div style={{cursor: 'pointer',display: 'flex', justifyContent: 'flex-start', alignItems: 'center', marginTop: '10px'}} onClick={()=>{
                        window.location.href = '/gallery';
                    }}>
                        <FaCameraRetro size={20} style={{marginRight: '20px'}}/> PICTURE GALLERY
                    </div>
                    <hr style={{border: '1px solid rgba(255,255,255,.2)',marginTop: '20px', marginBottom: '20px'}}></hr>
                    <div style={{cursor: 'pointer',display: 'flex', justifyContent: 'flex-start', alignItems: 'center', marginTop: '10px'}} onClick={()=>{
                        window.location.href = '/applications';
                    }}>
                        <FaWpforms size={20} style={{marginRight: '20px'}}/> PUPPY APPLICATIONS
                    </div>
                    <div style={{cursor: 'pointer',display: 'flex', justifyContent: 'flex-start', alignItems: 'center', marginTop: '10px'}} onClick={()=>{
                        window.location.href = '/newsletters';
                    }}>
                        <FaWpforms size={20} style={{marginRight: '20px'}}/> NEWSLETTER SIGNUPS
                    </div>
                    <div style={{cursor: 'pointer',display: 'flex', justifyContent: 'flex-start', alignItems: 'center', marginTop: '10px'}} onClick={()=>{
                        window.location.href = '/contact';
                    }}>
                        <FaWpforms size={20} style={{marginRight: '20px'}}/> CONTACT US ENTRIES
                    </div>
                </div>
            </div>)
    }
}

export default Toolbar;